import { render, staticRenderFns } from "./SamLabel.vue?vue&type=template&id=05704cf5&scoped=true&shadow"
import script from "./SamLabel.vue?vue&type=script&lang=js&shadow"
export * from "./SamLabel.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamLabel.vue?vue&type=style&index=0&id=05704cf5&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "05704cf5",
  null
  ,true
)

export default component.exports